const gbp = (v) => (v == null ? null : `£${Math.round(v).toLocaleString()}`);

function Row({ r, i }) {
  return (
    <div data-testid={`official-leo5-row-${i}`} className="mt-2 first:mt-1">
      <div className="font-chip text-2xl font-semibold text-[#4C1D95]">{gbp(r.median)}</div>
      <div className="text-[11px] text-stone-600 leading-snug">{r.label}</div>
      <div className="text-[10px] font-mono text-stone-400 mt-0.5">
        {r.subject_code}
        {r.broader_group ? " · broader subject group" : ""}
        {r.population ? ` · n = ${Math.round(r.population).toLocaleString()}` : ""}
        {r.lq != null && r.uq != null ? ` · ${gbp(r.lq)}–${gbp(r.uq)}` : ""}
        {r.cohort ? ` · graduated ${r.cohort}` : ""}
      </div>
    </div>
  );
}

export const OfficialLeo5 = ({ official }) => {
  const { mode, rows = [], benchmark, reason } = official;
  return (
    <div data-testid="official-leo5" data-mode={mode}>
      {mode === "provider_subject" && rows.map((r, i) => <Row key={`${r.subject_code}-${i}`} r={r} i={i} />)}
      {mode !== "provider_subject" && (
        <div data-testid="official-leo5-unavailable" className="font-chip text-base font-semibold text-stone-500 mt-1">
          Data not available
        </div>
      )}
      {mode !== "provider_subject" && reason && <div className="text-[10px] text-stone-400 mt-0.5">{reason}</div>}
      {benchmark && (
        <div data-testid="official-leo5-benchmark" className="mt-2 rounded border border-dashed border-stone-300 p-2">
          <div className="text-[10px] uppercase tracking-wider text-stone-500">National benchmark (not this university)</div>
          <div className="font-chip text-lg font-semibold text-stone-700">{gbp(benchmark.median)}</div>
          <div className="text-[11px] text-stone-600 leading-snug">{benchmark.label}</div>
        </div>
      )}
      {official.context?.length > 0 && (
        <div data-testid="official-leo5-context" className="mt-2 rounded border border-stone-200 bg-stone-50 p-2">
          <div className="text-[10px] uppercase tracking-wider text-stone-500">Also published by DfE (different cohort and scope)</div>
          {official.context.map((c, i) => (
            <div key={c.cah2_code} data-testid={`official-leo5-context-${i}`} className="mt-1">
              <span className="font-chip text-base font-semibold text-stone-700">{gbp(c.median)}</span>
              <span className="text-[11px] text-stone-600 ml-1">{c.label}</span>
              {c.population ? <span className="text-[10px] font-mono text-stone-400"> · n = {Math.round(c.population).toLocaleString()}</span> : null}
            </div>
          ))}
          <div className="text-[10px] text-stone-400 mt-1">Source: {official.context_source}. Not combined with the figure above.</div>
        </div>
      )}
      <div data-testid="official-leo5-source" className="text-[10px] text-stone-400 mt-2 leading-snug">
        Source: {official.source}. {official.cohort_note}
      </div>
    </div>
  );
};
